import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=92cd2d14&"
import script from "./DefaultFooter.vue?vue&type=script&lang=ts&"
export * from "./DefaultFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports